<div class="uk-grid">
  <div class="uk-width-1-1">
    <p class="uk-heading-divider">
      {{'Ogólne' | translate}}
    </p>
    <div class="uk-grid">
      <div class="uk-width-1-5">
        <label>Sposób utworzenia</label>
        <input class="uk-input"
               disabled
               [ngModel]="shipmentInternalInfo?.shipment.creator"
        >
      </div>
      <div class="uk-width-1-5">
        <label>Zwrot</label>
        <input class="uk-input"
               disabled
               value="{{shipmentInternalInfo?.shipment.is_return ? 'Tak' : 'Nie'}}"
        >
      </div>
      <div class="uk-width-1-5">
        <label>Przesyła emag</label>
        <input class="uk-input"
               disabled
               value="{{shipmentInternalInfo?.shipment.is_emag ? 'Tak' : 'Nie'}}"
        >
      </div>
      <div class="uk-width-1-5">
        <label *ngIf="shipmentInternalInfo?.shipment.is_return">rejestracja u kuriera f. mile</label>
        <label *ngIf="!shipmentInternalInfo?.shipment.is_return">rejestracja u kuriera l. mile</label>
        <input class="uk-input"
               disabled
               [ngModel]="shipmentInternalInfo?.shipment.correctly_requested_at"
        >
      </div>
      <div class="uk-width-1-5" *ngIf="shipmentInternalInfo?.shipment.is_return">
        <label>Usługa kuriera first mile</label>
        <input class="uk-input"
               disabled
               [ngModel]="shipmentInternalInfo?.shipment.in_service"
        >
      </div>
      <div class="uk-width-1-5" *ngIf="!shipmentInternalInfo?.shipment.is_return">
        <label>Usługa kuriera last mile</label>
        <input class="uk-input"
               disabled
               [ngModel]="shipmentInternalInfo?.shipment.out_service"
        >
      </div>
    </div>
  </div>
  <div class="uk-width-1-1" *ngFor="let parcel of shipmentInternalInfo?.parcels ?? []">
    <br>
    <p class="uk-heading-divider">
      {{parcel.internal_number}}
    </p>
    <div class="uk-grid">
      <div class="uk-width-1-5">
        <label>Licznik opóźnienia</label>
        <input class="uk-input"
               disabled
               [ngModel]="parcel.delay_counter"
        >
      </div>
      <div class="uk-width-1-5">
        <label title="Ostatnia synchronizacja statusów">Ostatnia synchro. statusów</label>
        <input class="uk-input"
               disabled
               [ngModel]="parcel.status_checked_at"
        >
      </div>
      <div class="uk-width-1-5">
        <label title="Odczytany alias klienta">Odczytany alias klienta</label>
        <input class="uk-input"
               disabled
               [ngModel]="parcel.read_client_alias"
        >
      </div>
      <div class="uk-width-1-5">
        <label>Procesowalna</label>
        <input class="uk-input"
               disabled
               value="{{parcel.processable ? 'Tak' : 'Nie'}}"
        >
      </div>
      <div class="uk-width-1-1"
          *ngIf="null !== parcel.error_message"
      >
        <label>Treść błędu</label>
        <input class="uk-input"
               disabled
               [ngModel]="parcel.error_message"
        >
      </div>
  </div>
  </div>

  <div *ngIf="[] != shipmentInternalInfo?.problems ?? []"
       class="uk-width-1-1 mt-10"
  >
    <p class="uk-heading-divider">
     Rozpoznane problemy
    </p>

    <table class="uk-table uk-table-striped mt-23">
      <tr>
        <th style="width: 25%; text-align: center">
          Rodzaj
        </th>
        <th>
          {{'status' | translate}}
        </th>
        <th>
          {{'Data rozwiazania' | translate}}
        </th>
        <td>
        </td>
      </tr>
      <tr *ngFor="let problem of shipmentInternalInfo?.problems ?? []">
        <td>
          {{problem.rule.name}}
        </td>
        <td>
          {{problem.status}}
        </td>
        <td>
          {{problem.resolved_at}}
          <br>
          <small *ngIf="null !== problem.resolved_by">{{problem.resolved_by.email}}</small>
        </td>
        <td>
          <div class="uk-grid">
            <div>
              <button class="uk-button  uk-button-primary text-center"
                      *ngIf="null !== problem.payload"
                      (click)="openPayloadModal(problem.payload)"
              >
                Zobacz payload
              </button>
            </div>
            <div
              class="uk-width-1-2"
              *ngIf="'SHIPMENT_REGISTRATION_FAILED' === problem.rule.code && 'reported' === problem.status"
            >
              <button class="uk-button uk-button-primary text-center"

                      (click)="reTryRegister()"
              >
                Zarejestruj przesyłkę
              </button>
            </div>
          </div>
        </td>
      </tr>
    </table>
  </div>

  <div id="problemPayloadModal" uk-modal class="problemPayloadModal">
    <div class="uk-modal-dialog" style="width: 80% !important;">
      <button class="uk-modal-close-default" type="button" uk-close></button>
      <div class="uk-modal-header">
        <h2 class="uk-modal-title">Zawartość payloadu</h2>
      </div>
      <div class="uk-modal-body">
        <div id="payloadQuote">

        </div>
      </div>
    </div>
  </div>
</div>




